import { SubscriptionPricesResponse } from 'src/services/subscriptionApi/interfaces/subscriptionApi.interface'

import { SubscriptionCardData } from '../SubscriptionCard'
import {
  annuallyPricingData,
  monthlyPricingData,
} from '../subscriptionCardsData'

type PlanKey = 'daily' | 'monthly' | 'weekly'

const planIdToKey: Record<string, PlanKey> = {
  'daily-data-fetch': 'daily',
  'monthly-data-fetch': 'monthly',
  'weekly-data-fetch': 'weekly',
}

export const mergePricesWithFeatures = (
  pricesResponse: SubscriptionPricesResponse | undefined,
  billingPeriod: 'annually' | 'monthly'
): SubscriptionCardData[] => {
  const baseData =
    billingPeriod === 'monthly' ? monthlyPricingData : annuallyPricingData

  if (!pricesResponse?.data?.plans) {
    return baseData
  }

  const { plans } = pricesResponse.data
  const billingInterval = billingPeriod === 'monthly' ? 'monthly' : 'annual'

  return baseData.map((card) => {
    const planKey = planIdToKey[card.id]
    if (!planKey || !plans[planKey]) {
      return card
    }

    const planPrices = plans[planKey]
    const priceInfo = planPrices[billingInterval]

    if (!priceInfo) {
      return card
    }

    const priceInDollars = priceInfo.amount / 100

    if (billingPeriod === 'annually') {
      const monthlyPriceInfo = planPrices.monthly
      const monthlyPriceInDollars = monthlyPriceInfo
        ? monthlyPriceInfo.amount / 100
        : card.price

      return {
        ...card,
        originalPrice: monthlyPriceInDollars,
        price: Math.round(priceInDollars / 12),
        priceId: priceInfo.priceId,
      }
    }

    return {
      ...card,
      price: priceInDollars,
      priceId: priceInfo.priceId,
    }
  })
}
